/* eslint-disable no-extra-boolean-cast */
/* eslint-disable camelcase */
/* eslint-disable jsx-quotes */
/* eslint-disable quotes */
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Breadcrumb from '../../breadcrumb/breadcrumb';
import FileUploader from '../../file-uploader/file-uploader';
import { uploadFile } from '../section.actions';
import {
    fetchTypesTests,
    asyncFetchCourseTemplateTests,
} from '../../courses/courses.actions';
import { asyncFetchClassTemplateTests } from '../../classes/classes.actions';
import ContentTypes from '../../../utils/content-types';
import latinize from '../../../utils/latinize';
import { withRouter } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import moment from 'moment';

import BannerImg from '../../../images/img-default.png';
import routes from '../../../utils/routes';
import SelectTest from '../../SelectTest';

class ListWrapper extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            type: Object.keys(ContentTypes)[0],
            hasExpiration: !!props.expirationDate,
            errorMsg: '',
            isScrolling: false,
            typeTestsValues: {},
        };
        this.toggleScroll = this.toggleScroll.bind(this);
    }

    componentDidMount() {
        window.addEventListener('scroll', this.toggleScroll);
        const {
            match,
            course_template_tests,
            class_template_tests,
            classId,
            courseId,
        } = this.props;
        const isCourse = match.path.startsWith(routes.COURSE_RESOURCES());
        if (!isCourse) {
            if (classId) {
                this.props.asyncFetchClassTemplateTests({ classId });
            }
            this.setState({
                typeTestsValues: class_template_tests,
            });
        } else if (isCourse) {
            if (courseId) {
                this.props.asyncFetchCourseTemplateTests({ courseId });
            }
            this.setState({
                typeTestsValues: course_template_tests,
            });
        }
        this.props.fetchTypesTests();
    }

    componentDidUpdate(prevProps) {
        const {
            typeTests,
            typeTestsValues: typeTestsValuesProps,
            classId,
            courseId,
            match,
            class_template_tests,
            course_template_tests,
        } = this.props;

        const { typeTestsValues } = this.state;
        if (
            typeTests !== prevProps.typeTests &&
            Object.keys(typeTestsValues).length === 0
        ) {
            const toSetTypeTestsValues = this.setTypeTestsToValues(typeTests);
            this.setState({
                typeTestsValues: toSetTypeTestsValues,
            });
        }

        if (typeTestsValuesProps !== prevProps.typeTestsValues) {
            const toSetTypeTestsValues = this.setTypeTestsToValues(
                typeTests,
                typeTestsValuesProps,
            );
            this.setState({
                typeTestsValues: toSetTypeTestsValues,
            });
        }

        const isCourse = match.path.startsWith(routes.COURSE_RESOURCES());
        if (classId !== prevProps.classId && !isCourse) {
            this.props.asyncFetchClassTemplateTests({ classId });
        }

        if (courseId !== prevProps.courseId && isCourse) {
            this.props.asyncFetchCourseTemplateTests({ courseId });
        }

        if (
            class_template_tests !== prevProps.class_template_tests &&
            !isCourse
        ) {
            this.setState({
                typeTestsValues: class_template_tests,
            });
        }

        if (
            course_template_tests !== prevProps.course_template_tests &&
            isCourse
        ) {
            this.setState({
                typeTestsValues: course_template_tests,
            });
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.toggleScroll);
    }

    setTypeTestsToValues(typeTests, alternativeValues = null) {
        const { typeTestsValues } = this.state;
        const interableValues = alternativeValues
            ? alternativeValues
            : typeTestsValues;
        const auxToSetTypeTestsValues = {};
        typeTests.map(typeTest => {
            Object.assign(auxToSetTypeTestsValues, {
                [typeTest.id]: interableValues[typeTest.id] || null,
            });
        });
        const toSetTypeTestsValues = auxToSetTypeTestsValues;

        return toSetTypeTestsValues;
    }

    handleChangeSelectTest(valueSelect, testId) {
        const { typeTestsValues } = this.state;
        const auxValuesTest = typeTestsValues;

        this.props.updateNestedItem('typeTestsValues', {
            ...auxValuesTest,
            [testId]: !!valueSelect ? valueSelect : null,
        });
    }

    toggleScroll() {
        let scroll = window.scrollY;
        if (scroll > 100) {
            this.setState({ isScrolling: true });
        } else {
            this.setState({ isScrolling: false });
        }
    }

    render() {
        const { children, isActivity, match, typeTests, tests, type = undefined } = this.props;
        const { typeTestsValues } = this.state;
        const showClassInfo = !!this.props.classId;
        const isCard =
            !this.props.classId && !this.props.courseId && !isActivity;
        const isCourse = match.path.startsWith(routes.COURSE_RESOURCES());
        const showPeriodInfo = !isCourse && (showClassInfo || isCard);

        return (
            <div>
                {this.renderBanner()}
                <div className="class-description-wrapper">
                    <p className="description-title">Descrição</p>
                    {this.renderDescription()}
                    {isActivity && this.renderActivitiesCompletion()}
                    {showPeriodInfo && this.renderPeriodInfo()}
                    {showClassInfo && this.renderTrainerInfo()}
                    {showClassInfo && this.renderCenterInfo()}
                    {(typeTests && (type === 'CLASS' || type === 'COURSE')) &&
                        typeTests.map((typeTest, index) => (
                            <SelectTest
                                key={index}
                                name={typeTest.label}
                                typeTest={typeTest}
                                tests={tests}
                                onChange={this.handleChangeSelectTest.bind(
                                    this,
                                )}
                                value={typeTestsValues[typeTest.id] || ''}
                            />
                        ))}
                </div>
                {this.renderAddItem()}
                <div className="class-resources-wrapper">{children}</div>
            </div>
        );
    }

    orderBy(key, array) {
        return array.sort((a, b) => {
            if (a[key] < b[key]) {
                return -1;
            }
            if (a[key] > b[key]) {
                return 1;
            }
            return 0;
        });
    }

    renderCenterInfo = () => {
        const { centers } = this.props;
        const orderedCenter = this.orderBy('name', centers);
        return (
            <div className="expiration">
                <div className="inputs-container">
                    <div className="input-wrapper">
                        <label>Unidade:</label>
                        <select
                            onChange={this.handleChange}
                            id="centerId"
                            name="centerId"
                            value={this.props.centerId}
                        >
                            {orderedCenter.map(c => (
                                <option key={c.id} value={c.id}>
                                    {c.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        );
    };

    renderTrainerInfo = () => {
        const { trainers } = this.props;
        return (
            <div className="expiration">
                <div className="inputs-container">
                    <div className="input-wrapper">
                        <label>Trainer:</label>
                        <select
                            onChange={this.handleChange}
                            id="trainerId"
                            name="trainerId"
                            value={this.props.trainerId}
                        >
                            {trainers.map(t => (
                                <option key={t.userId} value={t.userId}>
                                    {t.obsoleteName}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        );
    };

    renderPeriodInfo = () => {
        const { startDate, endDate } = this.props;
        return (
            <div className="expiration">
                <div className="inputs-container">
                    <div className="input-wrapper date-select">
                        <label>Início:</label>
                        <DatePicker
                            readOnly
                            minDate={moment()}
                            maxDate={
                                endDate
                                    ? moment(endDate).subtract(1, 'd')
                                    : null
                            }
                            selected={startDate ? moment(startDate) : null}
                            isClearable={true}
                            name="startDate"
                            id="startDate"
                            onChange={date =>
                                this.props.updateNestedItem(
                                    'startDate',
                                    date ? date.toISOString() : null,
                                )
                            }
                        />
                    </div>
                    <div className="input-wrapper date-select">
                        <label>Término:</label>
                        <DatePicker
                            readOnly
                            minDate={
                                startDate
                                    ? moment(startDate).add(1, 'd')
                                    : moment().add(1, 'd')
                            }
                            selected={endDate ? moment(endDate) : null}
                            isClearable={true}
                            name="endDate"
                            id="endDate"
                            onChange={date =>
                                this.props.updateNestedItem(
                                    'endDate',
                                    date ? date.toISOString() : null,
                                )
                            }
                        />
                    </div>
                </div>
            </div>
        );
    };

    onBlurValidation = toChange => {
        if (parseInt(this.props.mandatoryCount, 10) > this.props.items.length) {
            this.setState({
                errorMsg:
                    'Quantidade requerida deve ser menor ou igual a quantidade de atividades',
            });
            this.props.updateNestedItem(toChange, '');
        }
        if (
            parseInt(this.props.neededCount, 10) >
            parseInt(this.props.mandatoryCount, 10)
        ) {
            this.setState({
                errorMsg:
                    'Quantidade obrigatória deve ser menor ou igual a quantidade de requerida',
            });
            this.props.updateNestedItem(toChange, '');
        }
        if (
            parseInt(this.props.exchangeCount, 10) >
            parseInt(this.props.neededCount, 10)
        ) {
            this.setState({
                errorMsg:
                    'Quantidade de trocas deve ser menor ou igual a quantidade de obrigatória',
            });
            this.props.updateNestedItem(toChange, '');
        }

        if (
            parseInt(this.props.mandatoryCount, 10) < 0 ||
            parseInt(this.props.neededCount, 10) < 0 ||
            parseInt(this.props.exchangeCount, 10) < 0
        ) {
            this.setState({ errorMsg: 'nenhum dos valores pode ser negativo' });
            this.props.updateNestedItem(toChange, '');
        }
    };

    renderActivitiesCompletion = () => (
        <div className="completion-act">
            <div className="completion-item">
                <span>Quantidade requerida:</span>
                <input
                    value={this.props.mandatoryCount || ''}
                    onBlur={() =>
                        this.onBlurValidation(
                            activityInputTypes.MANDATORY_COUNT,
                        )
                    }
                    onChange={this.handleChange}
                    name="mandatoryCount"
                    type="number"
                />
            </div>
            <div className="completion-item">
                <span>Quantidade obrigatória:</span>
                <input
                    value={this.props.neededCount || ''}
                    onBlur={() =>
                        this.onBlurValidation(activityInputTypes.NEEDED_COUNT)
                    }
                    onChange={this.handleChange}
                    name="neededCount"
                    type="number"
                />
            </div>
            <div className="completion-item">
                <span>Quantidade de trocas:</span>
                <input
                    value={this.props.exchangeCount || ''}
                    onBlur={() =>
                        this.onBlurValidation(activityInputTypes.EXCHANGE_COUNT)
                    }
                    onChange={this.handleChange}
                    name="exchangeCount"
                    type="number"
                />
            </div>
            {this.state.errorMsg && (
                <span className="completion-msg">{this.state.errorMsg}</span>
            )}
        </div>
    );

    renderBanner = () => {
        const { picture, links } = this.props;

        return (
            <div className="section-banner-wrapper">
                <div className="section-banner">
                    <img src={picture ? picture : BannerImg} alt="banner" />
                </div>
                <div className="section-banner-foreground">
                    <div className="section-breadcrumb">
                        <Breadcrumb items={links} />
                    </div>
                    {this.renderTitle()}
                </div>
                <div className="edition-toolbar" title="Trocar imagem">
                    <FileUploader
                        handleFileChange={img =>
                            drawScaledImage(img).then(this.handlePictureUpload)
                        }
                    >
                        <a>
                            <i className="fa fa-pencil" />
                        </a>
                    </FileUploader>
                </div>
            </div>
        );
    };

    renderTitle = () => {
        const {
            title,
            courseName = '',
            className,
            classId,
            courseId,
        } = this.props;
        if (courseId) {
            return (
                <React.Fragment>
                    {!classId ? (
                        <div className="input-wrapper">
                            <label htmlFor="courseName">Nome do curso</label>
                            <input
                                id="courseName"
                                value={courseName || ''}
                                name="courseName"
                                placeholder="Nome do Curso"
                                onChange={this.handleChange}
                            />
                        </div>
                    ) : (
                        <span className="course-name">{courseName}</span>
                    )}
                    {classId ? (
                        <div
                            className="input-wrapper"
                            style={{ marginTop: '15px' }}
                        >
                            <label htmlFor="className">Nome da turma</label>
                            <input
                                id="className"
                                value={className || ''}
                                name="className"
                                onChange={this.handleChange}
                                style={{ width: '50%' }}
                            />
                        </div>
                    ) : (
                        <span className="class-name">{className}</span>
                    )}
                </React.Fragment>
            );
        } else {
            return (
                <div className="input-wrapper">
                    <label htmlFor="sectionName">Nome da Seção</label>
                    <input
                        value={title || ''}
                        id="sectionName"
                        name="title"
                        onBlur={this.onBlur}
                        onChange={this.handleChange}
                        style={{ width: '50%' }}
                    />
                </div>
            );
        }
    };

    renderDescription = () => {
        const { description = '' } = this.props;
        return (
            <textarea
                placeholder="Escreva aqui uma descrição breve"
                rows={5}
                value={description}
                name="description"
                onChange={this.handleChange}
            />
        );
    };

    renderAddItem = () => {
        const { children, addNewItem } = this.props;
        const { isScrolling } = this.state;
        return (
            <div className="add-item-wrapper">
                {!children && (
                    <div className="card-types-selection">
                        {Object.keys(ContentTypes).map(type => (
                            <div key={type}>
                                <input
                                    type="radio"
                                    name="type"
                                    value={type}
                                    checked={type === this.state.type}
                                    onChange={e =>
                                        this.setState({ type: e.target.value })
                                    }
                                />
                                <span>{ContentTypes[type].name}</span>
                            </div>
                        ))}
                    </div>
                )}
                <button
                    className={`add-item-btn ${isScrolling ? 'top' : ''}`}
                    onClick={() => {
                        addNewItem(this.state.type);
                        window.scrollTo(0, document.body.scrollHeight);
                    }}
                    title="Adicionar item"
                >
                    <i className="fa fa-plus" />
                </button>
            </div>
        );
    };

    handlePictureUpload = arrayBufer => {
        this.props.uploadFile(arrayBufer, url =>
            this.props.updateNestedItem('picture', url),
        );
    };

    handleChange = ({ target }) => {
        this.setState({ errorMsg: '' });
        this.props.updateNestedItem(target.name, target.value);
    };

    handleExpirationChange = ({ target }) => {
        this.setState({ hasExpiration: !!target.value });
        target.value
            ? this.props.updateNestedItem(target.name, moment())
            : this.props.updateNestedItem(target.name, '');
    };

    onBlur = ({ target }) => {
        if (target.value === '') {
            return;
        }
        const { match, history } = this.props;
        const id = latinize.urlfy(target.value);
        this.props.updateNestedItem('id', id);
        history.replace(match.url.replace(match.params.id, id));
    };
}

const activityInputTypes = {
    MANDATORY_COUNT: 'mandatoryCount',
    NEEDED_COUNT: 'neededCount',
    EXCHANGE_COUNT: 'exchangeCount',
};

export default connect(
    ({ courses, classes }) => ({
        typeTests: courses.typeTests,
        tests: courses.tests,
        class_template_tests: classes.class_template_tests,
        course_template_tests: courses.course_template_tests,
    }),
    dispatch =>
        bindActionCreators(
            {
                uploadFile,
                fetchTypesTests,
                asyncFetchClassTemplateTests,
                asyncFetchCourseTemplateTests,
            },
            dispatch,
        ),
)(withRouter(ListWrapper));

const MAX_IMG_SIZE = { width: 1280, height: 720 };

function drawScaledImage(img, fileName = 'picture') {
    return drawImage(img)
        .then(canvas => canvasToBlob(canvas, fileName))
        .then(blob => blobToArrayBuffer(blob));
}

function drawImage(image) {
    return new Promise(resolve => {
        const img = new Image();
        img.onload = function () {
            const xScale = img.width / MAX_IMG_SIZE.width;
            const yScale = img.height / MAX_IMG_SIZE.height;
            const scale = Math.max(xScale, yScale, 1);

            const canvas = document.createElement('canvas');
            canvas.width = Math.floor(img.width / scale);
            canvas.height = Math.floor(img.height / scale);
            canvas
                .getContext('2d')
                .drawImage(img, 0, 0, canvas.width, canvas.height);
            resolve(canvas);
        };
        img.src = image;
    });
}

function canvasToBlob(canvas, fileName) {
    return new Promise(resolve => {
        canvas.toBlob(file => {
            file.name = fileName;
            resolve(file);
        }, 'image/jpeg');
    });
}

function blobToArrayBuffer(blob) {
    return new Promise(resolve => {
        const fileReader = new FileReader();
        fileReader.onload = function ({ target }) {
            resolve(target.result);
        };
        fileReader.readAsArrayBuffer(blob);
    });
}



// WEBPACK FOOTER //
// ./src/components/section/components/list-wrapper.js